import { render, staticRenderFns } from "./FormCitizenship.vue?vue&type=template&id=38dd7488&"
import script from "./FormCitizenship.vue?vue&type=script&lang=ts&"
export * from "./FormCitizenship.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dd7488')) {
      api.createRecord('38dd7488', component.options)
    } else {
      api.reload('38dd7488', component.options)
    }
    module.hot.accept("./FormCitizenship.vue?vue&type=template&id=38dd7488&", function () {
      api.rerender('38dd7488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/form/FormCitizenship.vue"
export default component.exports